export class MainCoverage {
    constructor({ coverages = [], price = 0, monthlyPrice = 0 }) {
        this.coverages = coverages;
        this.price = price;
        this.monthlyPrice = monthlyPrice;
    }
}
